import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col, Button } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import TraderRequestsList from "./TraderRequestsList"
import { GetTraderRequests } from "helpers/backend_helper"
import { useLoading } from "helpers/custom_hooks"
import { IsTraderCompany } from "helpers/misc_helpers"

const TraderRequests = () => {
  const [requests, setRequests] = useState([])
  const [loading, setLoading] = useState(true)
  const setGlobalLoading = useLoading()
  const isTrader = IsTraderCompany()

  const loadData = async () => {
    setLoading(true)
    setGlobalLoading(true)
    try {
      const data = await GetTraderRequests()
      setRequests(data || [])
    } catch (error) {
      console.error("Error loading trader requests:", error)
      setRequests([])
    }
    setLoading(false)
    setGlobalLoading(false)
  }

  useEffect(() => {
    loadData()
  }, [])

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Excess Price Check" breadcrumbItem="Excess Price Check" />
        <Row>
          <Col xs={12}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="mb-0">
                {isTrader ? "Open Excess Price Checks" : "My Excess Price Checks"}
              </h4>
              {!isTrader && (
                <Link to="/trader-requests/new">
                  <Button color="primary">
                    <i className="bx bx-plus me-1"></i>
                    New Request
                  </Button>
                </Link>
              )}
            </div>
            {!loading && (
              <TraderRequestsList requests={requests} isTrader={isTrader} />
            )}
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default TraderRequests
